'use client';

import { c as _c } from "react/compiler-runtime";
import type { InterfaceInputToken, Point, Rewards } from '@morpho-org/dapp-core';
import { DataList } from '@morpho-org/ui-v6/client';
import type { MerklTarget } from '@/components/common/RewardsHoverCard/MerklRewardsHoverCard';
import { formatApyPercentage } from '@/helpers/formatters';
import { InstantApyDataLine } from './components';
export interface ApyDataListProps {
  apy?: bigint | null;
  netApy?: bigint | null;
  apy7d?: number | null;
  apy30d?: number | null;
  apy90d?: number | null;
  rewards: Rewards[];
  points: Point[];
  asset?: InterfaceInputToken | null;
  performanceFee?: bigint | null;
  merklContext?: MerklTarget | null;
}
const ApyCards = t0 => {
  const $ = _c(32);
  const {
    rewards,
    apy,
    netApy,
    apy7d,
    apy30d,
    apy90d,
    asset,
    performanceFee,
    merklContext,
    points
  } = t0;
  let t1;
  if ($[0] !== apy7d) {
    t1 = formatApyPercentage(apy7d);
    $[0] = apy7d;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formatted7dValue = t1;
  let t2;
  if ($[2] !== apy30d) {
    t2 = formatApyPercentage(apy30d);
    $[2] = apy30d;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const formatted30dValue = t2;
  let t3;
  if ($[4] !== apy90d) {
    t3 = formatApyPercentage(apy90d);
    $[4] = apy90d;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const formatted90dValue = t3;
  let t4;
  if ($[6] !== apy || $[7] !== asset || $[8] !== merklContext || $[9] !== netApy || $[10] !== performanceFee || $[11] !== points || $[12] !== rewards) {
    t4 = <InstantApyDataLine apy={apy} netApy={netApy} rewards={rewards} points={points} asset={asset} merklContext={merklContext} performanceFee={performanceFee} />;
    $[6] = apy;
    $[7] = asset;
    $[8] = merklContext;
    $[9] = netApy;
    $[10] = performanceFee;
    $[11] = points;
    $[12] = rewards;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DataList.LeftItem label="7D APY" tooltip="Weekly vault net APY, including fees but excluding rewards." />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== formatted7dValue) {
    t6 = <DataList.Line>{t5}<DataList.RightItem label={formatted7dValue} /></DataList.Line>;
    $[15] = formatted7dValue;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <DataList.Column>{t4}{t6}</DataList.Column>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DataList.LeftItem label="30D APY" tooltip="Monthly vault net APY, including fees but excluding rewards." />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== formatted30dValue) {
    t9 = <DataList.Line>{t8}<DataList.RightItem label={formatted30dValue} /></DataList.Line>;
    $[21] = formatted30dValue;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <DataList.LeftItem label="90D APY" tooltip="90D vault net APY, including fees but excluding rewards." />;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== formatted90dValue) {
    t11 = <DataList.Line>{t10}<DataList.RightItem label={formatted90dValue} /></DataList.Line>;
    $[24] = formatted90dValue;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t9) {
    t12 = <DataList.Column>{t9}{t11}</DataList.Column>;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t7) {
    t13 = <DataList.Root fullWidth={true}>{t7}{t12}</DataList.Root>;
    $[29] = t12;
    $[30] = t7;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
export default ApyCards;